import { fetchApi } from 'api/fetchApi';

export const getFileUrlForDownloading = async (
  apiMethod: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any,
  abortController?: AbortController,
): Promise<FileToDownloadInfo> => {
  const response = await fetchApi.post<string>(apiMethod, data, {
    responseType: 'arraybuffer',
    signal: abortController?.signal,
  });

  const blob = new Blob([response.data], {
    type: 'application/octet-stream',
  });

  const url = window.URL.createObjectURL(blob);
  const fileName = getFileNameFromContentDispositionHeader(response.headers['content-disposition']);

  return { url, fileName };
};

const getFileNameFromContentDispositionHeader = (contentDispositionHeader: string) => {
  if (contentDispositionHeader && contentDispositionHeader.indexOf('attachment') !== -1) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contentDispositionHeader);

    if (matches != null && matches[1]) {
      return matches[1].replace(/['"]/g, '');
    }
  }

  return '';
};

export const createFakeLinkAndDownloadFile = ({ url, fileName }: { url: string; fileName: string }) => {
  const a = document.createElement('a');

  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export interface FileToDownloadInfo {
  fileName: string;
  url: string;
}
